import { useEffect, useMemo, useState } from 'react'
import Input from '../../ui/Input'
import Label from '../../ui/Label'
import { selectCurrentModalType } from '../../../features/modal/modalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentProduct, selectNewProduct, selectNewProductCategoryName, updateNewProduct } from '../../../features/product/productSlice';
import { useProductForm } from '../../../hooks/product/useProductForm'
import { useImageUpload } from '../../../hooks/product/useImageUpload'
import ProdModAddOns from '../../layout/Admin/common/ProdModAddOns'
import ProductModalHeader from '../../common/headers/ProductModalHeader'
import ProdModImgPreview from '../../layout/Admin/common/ProdModImgPreview'
import ProdModTemperature from '../../layout/Admin/common/ProdModTemperature'
import ProdModCategory from '../../layout/Admin/common/ProdModCategory'
import ProdModAvailable from '../../layout/Admin/common/ProdModAvailable'
import ProdModSizes from '../../layout/Admin/common/ProdModSizes'
import { CATEGORY } from '../../../constant/constant';
import { useIsCategoryId, } from '../../../hooks/common/useCommon';

export interface NewProduct {
    price: number;
    productName: string;
    categoryID: number;
    image?: string;
    sizeId: number | null;
    description: string;
    status?: string;
    isAvailable: boolean;
}

export default function ProductModal() {
    
    const dispatch = useDispatch(); 
    const typeModal = useSelector(selectCurrentModalType);
    const selectedProduct = useSelector(selectCurrentProduct);
    const selectedCategoryName = useSelector(selectNewProductCategoryName);
    const newProductForm = useSelector(selectNewProduct);

    const [selectedAvailableOption, setSelectedAvailableOption] = useState<boolean>(selectedProduct?.isAvailable ?? true)
    const [isLoadingImg, setIsLoadingImg] = useState(true);
    const isPastries = useIsCategoryId(CATEGORY.pastries.id)
    const isBottleDrinks = useIsCategoryId(CATEGORY.bottleDrinks.id)
    const isRefresher = useIsCategoryId(CATEGORY.refresher.id)
    // const isDefaultCat = useIsCategoryName(CATEGORY.catDefault.catName)
    const isShowTemperatureAndSize: boolean = isBottleDrinks || isPastries || selectedCategoryName === undefined
    // const isShowAddOns = isRefresher || isBottleDrinks || selectedCategoryName === undefined

    const isSubmitDisabled = useMemo(() => {
        if (!newProductForm) return true;
    
        return !(
            newProductForm.category?.id &&
            newProductForm.productName?.trim() &&
            newProductForm.price > 0 &&
            (isPastries || newProductForm.size?.id) &&
            newProductForm.isAvailable !== null &&
            newProductForm.isAvailable !== undefined
        );
    }, [newProductForm, isPastries]);

    useEffect(() => {
        dispatch(updateNewProduct({ isAvailable: selectedAvailableOption }));
    }, [selectedAvailableOption, dispatch]);

    // const { sizesAvailable } = useInitializeProductForm(
    //     typeModal,
    //     selectedProduct,
    // );

    // const categoryName = selectedCategoryName ?? ''
    // const filteredSizesAPI = useGetSizes(
    //     categoryName,
    //     sizesAvailable
    // );

    const { 
        file: selectedFile,
        previewUrl: profilePreviewUrl, 
        handleUpload: handleImageUpload
    } = useImageUpload();
    const { 
        handleSaveNewProduct, 
        isLoadingCreateNewProduct, 
        isLoadingUpdateProduct 
    } = useProductForm({selectedFile});

    const defaultPrice = newProductForm.price === null || newProductForm.price === 0
    const prodPrice = defaultPrice ? '' : newProductForm.price.toString()

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]">
            <div className="relative w-[90vw] md:w-[75vw] lg:max-w-[50vw] bg-white rounded-lg shadow flex flex-col max-h-[90dvh]">
                <div className='px-5 py-2.5'>
                    <ProductModalHeader/>
                </div>
                <hr className="h-px bg-gray-200 border-0" />
                <div className="flex-1 overflow-y-auto p-5">
                    <ProdModImgPreview 
                        isLoadingImg={isLoadingImg}
                        profilePreviewUrl={profilePreviewUrl}
                        setIsLoadingImg={setIsLoadingImg}
                    />
                    <div className='pt-2 space-y-3'>
                        <div className='grid grid-cols-2 gap-3'>
                            <div className=''>
                                <Label label={'Product Name *'}/>
                                <Input
                                    type={'text'}
                                    value={newProductForm.productName}
                                    onChange={(e) => dispatch(updateNewProduct({ productName: e.target.value }))}
                                    required
                                />
                            </div>
                            <ProdModCategory/>
                            <ProdModTemperature/>
                            <div className='hidden'>
                                <Label label={'Image *'}/>
                                <Input
                                    type={'text'}
                                    value={newProductForm.image || ''}
                                    onChange={(e) => dispatch(updateNewProduct({ image: e.target.value ?? '' }))}
                                    required
                                />
                            </div>
                            <div className=''>
                                <Label label={'Price *'}/>
                                <Input
                                    type={'number'}
                                    value={prodPrice}
                                    onChange={(e) => dispatch(updateNewProduct({ price: Number(e.target.value) }))}
                                    required
                                />
                            </div>
                            {typeModal === 'updateProduct' && (
                                <ProdModAvailable
                                    setSelectedAvailableOption={setSelectedAvailableOption}
                                    selectedAvailableOption={selectedAvailableOption}
                                />
                            )}
                            <div className='h-full w-full'>
                                <Label label={'Upload Image '}/>
                                <label
                                    htmlFor="image"
                                    className="inline-block cursor-pointer bg-cbColor text-white px-2 py-1 rounded text-xs transition"
                                >
                                    Select Image
                                </label>
                                <input
                                    id="image"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageUpload}
                                    className="hidden"
                                />
                            </div>
                            <ProdModAddOns/>
                            <ProdModSizes/>
                        </div>
                        <div className=''>
                            <Label label={'Description (optional)'}/>
                            <Input
                                type={'text'}
                                value={newProductForm.description || ''}
                                onChange={(e) => dispatch(updateNewProduct({ description: e.target.value }))}
                            />
                        </div>
                    </div>
                </div>
                <div className="px-5 py-3 border-t bg-white">
                    <button 
                        // disabled={isSubmitDisabled || isLoadingCreateNewProduct || isLoadingUpdateProduct}
                        onClick={handleSaveNewProduct}
                        className={`w-full text-xs px-3 py-1.5 rounded font-medium transition-all ${isSubmitDisabled || isLoadingCreateNewProduct || isLoadingUpdateProduct ? 'cursor-not-allowed bg-gray-200 border text-black' : 'bg-cbColor text-white'}`}
                        >
                        {typeModal === 'newProduct' && 'Save New Product'}
                        {typeModal === 'updateProduct' && 'Save Update Product'}
                    </button>
                </div>
            </div>
        </div>
    )
}
